import type { GA4Offer, SanitisedOffer } from "@/types/offers";

export const getGAAttributes = (
    offer: SanitisedOffer | undefined,
    index: number | string | undefined
): GA4Offer => {
    return {
        index: index,
        item_id: offer?.id,
        item_brand: offer?.merchant?.data?.attributes?.name,
        item_name: offer?.freeSpinsText,
        item_variant: offer?.bonusText,
        item_category: offer?.merchant?.data?.attributes?.type,
        item_category2: offer?.freeSpinsValue,
        item_category3: offer?.deposit,
        item_category4: offer?.wagering,
        item_category5: offer?.rating,
    };
};
